import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-culver-city')!;
const CulverCityPage = () => <CityLandingPage data={data} />;
export default CulverCityPage;
